// src/App.jsx
// Providers + router. One login for all roles; each role's section is gated by
// ProtectedRoute. "/" sends a signed-in user to their home or to /login.

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import { homePathForRole } from "./config";

import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import NotFound from "./pages/NotFound";
import AdminDashboard from "./pages/dashboards/AdminDashboard";
import PractitionerDashboard from "./pages/dashboards/PractitionerDashboard";
import UserDashboard from "./pages/dashboards/UserDashboard";

// landing redirect: home for the role, or login
function Index() {
  const { user, isLoading } = useAuth();
  if (isLoading) return null;
  return <Navigate to={user ? homePathForRole(user.role) : "/login"} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <ToastProvider>
            <Routes>
              <Route path="/" element={<Index />} />
                           <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />

              <Route element={<ProtectedRoute allow={["admin"]} />}>
                <Route path="/admin/*" element={<AdminDashboard />} />
              </Route>
              <Route element={<ProtectedRoute allow={["practitioner"]} />}>
                <Route path="/practitioner/*" element={<PractitionerDashboard />} />
              </Route>
              <Route element={<ProtectedRoute allow={["user"]} />}>
                <Route path="/app/*" element={<UserDashboard />} />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
          </ToastProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}